module.exports = __webpack_public_path__ + "img/驻马店市.c64fdefd.png";